import { gql } from "apollo-angular";
import { CBF } from "./content-block";
import { DIF } from "./disclaimer-item";

export const VTF = gql`
fragment VTF on VerticalTabs {
  backgroundColor {
    color
  }
  header
  headerTag
  hTagId
  title
  content
  tabbedContentCollection (limit:10) {
    items {
      ...CBF
    }
  }
  rightColumnItemListCollection (limit:1) {
    items {
      ...CBF
    }
  }
  disclaimer{
    ...DIF
  }
}
${CBF}
${DIF}`;
